import React from "react";

export default function HowItWorksList({ children }) {
  return <div className='how-it-works__list'>{children}</div>;
}
